"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var react_i18next_1 = require("react-i18next");
var PostCode = function (_a) {
    var code = _a.code;
    var t = react_i18next_1.useTranslation('common').t;
    return (react_1.default.createElement("span", { className: styles_module_scss_1.default.post_code }, t('POST_CODE.CODE') + ': ' + code));
};
exports.default = PostCode;
